import { ITutorialPassos, MensagensPadrao } from '../../../Components/AdicionarAjuda';

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-da-fornecedor",

    filtroDeRazaoSocial: "campo-razao-social-filtros-do-fornecedor",
    filtroDeNomeFantasia: "campo-nome-fantasia-filtros-do-fornecedor",
    filtroDeCNPJ: "campo-cnpj-filtros-do-fornecedor",
    filtroDeAtivo: "campo-ativo-filtros-do-fornecedor",

    botaoListar: "botao-listar-fornecedor",
    botaoAdicionar: "botao-adicionar-fornecedor",
}

export const Classes = {
    botaoEditar: "botao-editar-fornecedor",
    botaoDesativar: "botao-desativar-fornecedor",
}

export const ConsultarFornecedor: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.razaoSocial, target: () => document.getElementById(IDs.filtroDeRazaoSocial)! },
        { ...MensagensPadrao.filtros.nomeFantasia, target: () => document.getElementById(IDs.filtroDeNomeFantasia)! },
        { ...MensagensPadrao.filtros.cnpj, target: () => document.getElementById(IDs.filtroDeCNPJ)! },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarFornecedor: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarFornecedor: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector("." + Classes.botaoEditar)! },
    ]
}

export const DesativarFornecedor: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector("." + Classes.botaoDesativar)! },
    ]
}
